import React from "react";
import krakenLogo from "../assets/logos/kraken.png";
import enzymeLogo from "../assets/logos/enzyme.png";
import qncLogo from "../assets/logos/qnc.png";
import arqnxsLogo from "../assets/logos/arqnxs.png";

const TrustBanner = () => {
  const logos = [
    { src: krakenLogo, alt: "Custody by Kraken", href: "https://www.kraken.com/institutions/custody" },
    { src: arqnxsLogo, alt: "ARQNXS", href: "https://www.arqnxs.com/" },
    { src: enzymeLogo, alt: "Built on Enzyme", href: "https://enzyme.finance/" },
    { src: qncLogo, alt: "QuantNexusCapital", href: "https://www.quantnexuscapital.com/" },
  ];

  // Duplicate logos to create infinite loop effect
  const scrollingLogos = [...logos, ...logos];

  return (
    <section className="bg-white py-8 overflow-hidden mb-6">
      <div className="container mx-auto max-w-5xl">
        <h3 className="mb-6 text-center text-sm uppercase tracking-widest text-neutral-600">
          Infrastructure&nbsp;&amp;&nbsp;Custody
        </h3>

        <div className="relative w-full overflow-hidden">
          <div className="flex animate-scroll whitespace-nowrap">
            {scrollingLogos.map((logo, i) => (
              <a
                key={i}
                href={logo.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 mx-20 opacity-80 grayscale hover:opacity-100 hover:grayscale-0 transition duration-300"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-12 sm:h-16 w-auto object-contain"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Tailwind keyframes for smooth scroll */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 50s linear infinite;
        }
      `}</style>
    </section>
  );
};

export default TrustBanner;
